import React from 'react';

// components
import InputLabel from '../../components/inputs/inputLabel';
import styled from 'styled-components';

import aampeTheme from '../../constants/aampeTheme';

interface WrapperProps {
    label?: string;
    children: React.ReactNode;
}

const SSOWrapper: React.FC<WrapperProps> = ({ label, children }) => {
    return (
        <Container>
            {label && <InputLabel label={label} />}
            {children}
        </Container>
    );
};

export default SSOWrapper;

const Container = styled.div({
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'flex-start',
    marginTop: aampeTheme.spacing(2),
    width: '100%',
    gap: aampeTheme.spacing(1),
});
